"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseQueryWithReauth = void 0;
var query_1 = require("@reduxjs/toolkit/query");
var client_1 = require("../features/slices/client");
var user_1 = require("../features/slices/user");
var session_1 = require("../features/thunks/session");
var auth_storage_1 = require("./auth-storage");
var legal_acceptance_1 = require("./legal-acceptance");
var SESSION_ID_HEADER = "X-Session-Id";
// Shared across every API slice so parallel 401s only trigger one refresh call.
var refreshPromise = null;
function refreshAccessToken(refreshToken, baseUrl, api) {
    return __awaiter(this, void 0, void 0, function () {
        var rawBaseQuery, sessionId, result, content, user, nextSession;
        var _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    rawBaseQuery = (0, query_1.fetchBaseQuery)({ baseUrl: baseUrl });
                    sessionId = api.getState().user.sessionId;
                    return [4 /*yield*/, rawBaseQuery({ url: "/v1/user/refresh", method: "POST", body: { refreshToken: refreshToken }, headers: (_a = {}, _a[SESSION_ID_HEADER] = sessionId, _a) }, api, {})];
                case 1:
                    result = _c.sent();
                    content = (_b = result.data) === null || _b === void 0 ? void 0 : _b.content;
                    if (result.error || !content) {
                        return [2 /*return*/, null];
                    }
                    user = api.getState().user;
                    nextSession = __assign(__assign({}, user), { token: content.token, refreshToken: content.refreshToken, expiresIn: content.expiresIn });
                    api.dispatch((0, user_1.setCredentials)(nextSession));
                    (0, auth_storage_1.saveAuthSession)(nextSession);
                    return [2 /*return*/, content.token];
            }
        });
    });
}
var baseQueryWithReauth = function (customBaseUrl) {
    return function (args, api, extraOptions) { return __awaiter(void 0, void 0, void 0, function () {
        var rawBaseQuery, result, user, newToken;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    rawBaseQuery = (0, query_1.fetchBaseQuery)({
                        baseUrl: customBaseUrl,
                        prepareHeaders: function (headers, _a) {
                            var getState = _a.getState;
                            var user = getState().user;
                            var token = user.token;
                            if (token) {
                                headers.set("Authorization", "Bearer ".concat(token));
                            }
                            if (user.sessionId) {
                                headers.set(SESSION_ID_HEADER, user.sessionId);
                            }
                            return headers;
                        },
                    });
                    return [4 /*yield*/, rawBaseQuery(args, api, extraOptions)];
                case 1:
                    result = _f.sent();
                    if (!(((_a = result.error) === null || _a === void 0 ? void 0 : _a.status) === 401)) return [3 /*break*/, 6];
                    user = api.getState().user;
                    if (!user.refreshToken) return [3 /*break*/, 5];
                    refreshPromise !== null && refreshPromise !== void 0 ? refreshPromise : (refreshPromise = refreshAccessToken(user.refreshToken, customBaseUrl, api));
                    return [4 /*yield*/, refreshPromise];
                case 2:
                    newToken = _f.sent();
                    refreshPromise = null;
                    if (!newToken) return [3 /*break*/, 4];
                    return [4 /*yield*/, rawBaseQuery(args, api, extraOptions)];
                case 3:
                    result = _f.sent();
                    _f.label = 4;
                case 4:
                    if (!newToken || ((_b = result.error) === null || _b === void 0 ? void 0 : _b.status) === 401) {
                        (0, auth_storage_1.markSessionExpired)();
                        api.dispatch((0, session_1.clearSessionThunk)());
                    }
                    return [3 /*break*/, 6];
                case 5:
                    api.dispatch((0, session_1.clearSessionThunk)());
                    _f.label = 6;
                case 6:
                    // The API refuses everything but billing/identity calls for a suspended client; flag it so ConsoleLayout redirects.
                    if (((_c = result.error) === null || _c === void 0 ? void 0 : _c.status) === 402 && ((_e = (_d = result.error.data) === null || _d === void 0 ? void 0 : _d.content) === null || _e === void 0 ? void 0 : _e.code) === "CLIENT_SUSPENDED") {
                        api.dispatch((0, client_1.markClientSuspended)());
                    }
                    // A policy update mid-session: send the user back to sign in, where they're asked to accept it.
                    // Sign-in and invitation requests carry no session and handle this response themselves; clearing
                    // here would reset the API state and abort their in-flight request before they could read it.
                    if ((0, legal_acceptance_1.getRequiredLegalVersion)(result.error) && api.getState().user.token) {
                        api.dispatch((0, session_1.clearSessionThunk)());
                    }
                    return [2 /*return*/, result];
            }
        });
    }); };
};
exports.baseQueryWithReauth = baseQueryWithReauth;
